export default {
  startLoading: 'Začať nakladanie',
  finishLoading: 'Dokončiť nakladanie',
  loadEditDisabled: 'Upravovať je možné iba "plánovanú" vsázku.',
  startLoad: 'Spustiť vsádzku',
  confirmStartLoad: 'Spustiť vsádzku "{load}"?',
  confirmStartLoading: 'Začať nakladanie "{load}"?',
  confirmFinishLoading: 'Dokončiť nakladanie "{load}"?',
};
